import React, {useEffect} from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { connect } from 'react-redux'

// components
import AybAttributeFilters from "./_filters";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {ColorFormatter} from "../../../components/tables/colorFormatter";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";

// labels
import { LIST, NO_DATA_FOUND } from "../../../components/i18n/i18n";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";

// actions
import {remove, search} from "../../../redux/actions/ayb/aybAttributeActions";
import {setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";

// services
import { aybAttributeService } from "../../../jwt/_services/ayb/aybAttributeService";


const AybAttributeList = props => {
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id

    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    useEffect(()=>{
        if(!filter)
            props.setFilter(
                {
                    fbDataBase : { id : fbDataBaseId },
                    item : { code : null }
                });
    })

    useEffect(() => {
        const _filter = {
            fbDataBase : { id : fbDataBaseId },
            item : { code : null }
        }
        refreshDataList(pageIndex, pageSize, _filter);
    }, [filter, pageIndex, pageSize]);

    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const refreshFiltered = _dataFilter => refreshDataList(pageIndex, pageSize, _dataFilter);

    const confirmDelete = data => ConfirmDelete({
            data,
            fbDataBaseId : fbDataBaseId,
            remove : props.remove
        });

    const colorFormatter = cell => <ColorFormatter color={cell}/>

    const actionsFormatter = (cell, row) => <>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => {
            props.setViewMode('FORM');
            props.setItem(row);
            props.setForm(true, false, false);
        }}/>
        <TranslateButton item={row} service={aybAttributeService} />
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: 'uid',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'code',
            text: 'Codigo'
        }, {
            dataField: 'title',
            text: 'Titulo'
        }, {
            dataField: 'color',
            text: "Color",
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '140px'},
            formatter: colorFormatter
        }, {
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '240px'},
            formatter: actionsFormatter
        }
    ];

    return ( <Card>

        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>

        <AybAttributeFilters refreshFiltered={refreshFiltered}/>

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || [] }
                columns={columns}
                noDataIndication={ NO_DATA_FOUND }
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card> )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    search,
    remove,
})

export default connect(mapStateToProps, mapActionsToProps)(AybAttributeList)